// extracted by mini-css-extract-plugin
module.exports = {"breaker":"ClientHr_breaker__NT4fM","block":"ClientHr_block__1biwB"};